import VamosComponent from "vamos/cockpit/Component";
import ODataModel from "sap/ui/model/odata/v4/ODataModel";
import ODataListBinding from "sap/ui/model/odata/v4/ODataListBinding";
import V4Context from "sap/ui/model/odata/v4/Context";

export default class BaseService {
    protected component: VamosComponent;
    protected model:ODataModel;

    protected path:string;
    protected listBinding: ODataListBinding;

    public constructor(component: VamosComponent, path?:string) {
        this.path = path;
        this.component = component;
        this.model = component.getModel() as ODataModel;
    }
    async loadAll():Promise<V4Context[]>{
        const listBinding:ODataListBinding = this.getListBinding();
        return await listBinding.requestContexts(0, Infinity);
    }

    protected getListBinding(): ODataListBinding{
        if(this.listBinding){
            this.listBinding.destroy();
        }
        this.listBinding = this.component.getModel().bindList(this.path) as ODataListBinding;
        return this.listBinding;

    }

}